import React from "react"
import styled from "styled-components"
import { useBlogPostsPreview } from "../hooks/useBlogPostsPreview"
import PostPreview from "../components/blog/blog-preview"
import Layout from "../components/layout/layout"
import SEO from "../components/layout/seo"

const StyledSection = styled.section`
  padding: 90px 16px;
  background-color: #000;
  @media (min-width: 768px) {
    padding: 160px 16px 170px;
  }
`
const Container = styled.div`
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 30px;
    max-width: 1170px;
    margin: 0 auto;
  }
`
const Blog = () => {
  const renderPosts = () => {
    const {
      blogPosts: { edges },
    } = useBlogPostsPreview()
    const posts = edges.map(
      (
        {
          node: {
            frontmatter: { title, featuredimage, date, author, description },
            fields: { slug },
          },
        },
        index
      ) => (
        <PostPreview
          key={slug}
          firstArticle={!index}
          slug={slug}
          title={title}
          featuredimage={featuredimage}
          date={date}
          author={author}
          description={description}
        />
      )
    )
    return posts
  }
  return (
    <Layout hideInstaPosts>
      <SEO
        title="Blog - marketing internetowy, trendy i nowości ze świata IT"
        description="Chętnie dzielimy się swoją wiedzą i doświadczeniem. Na naszym blogu poznasz najnowsze trendy, aktualny rynek jak i również wiele nowości ze świata IT."
        canonical="/blog"
      />
      <StyledSection>
        <Container>{renderPosts()}</Container>
      </StyledSection>
    </Layout>
  )
}

export default Blog
